// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"390e6d6c","213":"a503fac6","239":"9a8cb813","453":"ce332cf7","667":"21d44fb7","880":"622e7970","947":"dbb68930"}[chunkId] + ".chunk.js";
};